import { useContext } from "react";
import { ClinicaContext } from "../../../../context/clinica-context";
import PdfOrcamentoMisto from "./PdfOrcamentoMisto";

const MODELOS = {
  modelo1: PdfOrcamentoMisto,
};

function PdfOrcamentoMistoWrapper({ showSinglePage, orcamentoData }) {
  const { configuracoes } = useContext(ClinicaContext);
  const modeloKey =
    configuracoes?.configuracoes?.modelosDocumentos?.orcamento || "modelo1";
  const Modelo = MODELOS[modeloKey] ?? PdfOrcamentoMisto;

  return (
    <div>
      <Modelo orcamentoData={orcamentoData} showSingleP={showSinglePage} />
    </div>
  );
}

export default PdfOrcamentoMistoWrapper;
